import { CardItem } from './card-item';
import { CardSearchField } from './card-search-field';
import { CardsSearchMethod } from '../enums/cards-search-method';

export class CardCategory {
    public id: string;
    public title: string;
    public color: string;
    public rank: number = 0;
    public items: CardItem[] = [];
    public active: boolean = true;

    constructor(fields?: Partial<CardCategory>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }

    public setFilter(filterWord: string, filterFields: CardSearchField[]) {
        let newActive: boolean = false;

        for (let item of this.items) {
            if (filterWord == undefined || filterWord == '') {
                item.active = true;
            } else {
                let activeIt: boolean = false;

                for (let field of filterFields) {
                    if (field.method == CardsSearchMethod.IS) {
                        activeIt = activeIt || item[field.field] == filterWord;
                    } else if (field.method == CardsSearchMethod.CONTAINS) {
                        activeIt = activeIt || item[field.field].toLocaleLowerCase().includes(filterWord.toLocaleLowerCase());
                    }

                    if (activeIt) {
                        break;
                    }
                }

                item.active = activeIt;
            }

            newActive = newActive || item.active;
        }

        this.active = newActive;
    }

    public get oneHasImage(): boolean {
        let result: boolean = false;

        for (let item of this.items) {
            result = item.image != undefined && item.image != '' && item.image != null;

            if (result) {
                break;
            }
        }

        return result;
    }

    // public filterItemsByNameOrId(filterWord: string): CardItem[] {
    //     return this.items.filter(item => item.id == filterWord || item.title.toLocaleLowerCase().includes(filterWord.toLocaleLowerCase()));
    // }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/models/card-category.ts